<template>
  <q-slide-item
    :right-color="removeIcon(guestTickets.orderItems).color"
    class="bg-responsive"
    @right="resetSlide => $emit('delete', guestTickets.orderItems, resetSlide)"
    @click="!viewOnly && $emit('edit', guestTickets.lastOrderItem)"
  >
    <template
      v-if="!viewOnly && guestTickets.firstOrderItem.operative && $_.isNil(activityTicket)"
      #right
    >
      <q-icon
        left
        :name="removeIcon(guestTickets.orderItems).icon"
        @click.stop="resetSlide => $emit('delete', guestTickets.orderItems, resetSlide)"
      />
      {{ removeIcon(guestTickets.orderItems).label }}
    </template>

    <q-item
      class="q-px-sm"
      :class="`state-${guestTickets.firstOrderItem.state}`"
    >
      <q-item-section
        v-if="($register || isDrawer) && (currentCircuit.posOptions.show_images_in_cart || !$register)"
        top
        class="col column text-center q-mt-xs items-center"
        :style="{ 'max-width': isDrawer || $register || $q.screen.lt.sm ? '50px' : '100px' }"
        avatar
      >
        <q-avatar
          class="bg-green-3"
          text-color="white"
        >
          {{ guestTickets.ticketType.displayName[0] }}
        </q-avatar>
      </q-item-section>

      <q-item-section class="col">
        <template v-if="$register">
          <q-item-label
            overline
            class="text-uppercase"
          >
            {{ guestTickets.firstOrderItem.title }} -
            <i18n-n
              class="text-weight-bolder"
              tag="span"
              :value="guestTickets.individualPrice"
              format="currency"
              scope="global"
            />
          </q-item-label>
          <q-item-label>
            {{ movieOrActivityLabel }}
          </q-item-label>
        </template>
        <q-item-label v-else>
          {{ ticketTypeDisplayName }}
          <q-chip
            v-if="guestTickets.firstOrderItem.appliedVoucher"
            rounded
            dense
            :color="guestTickets.firstOrderItem.appliedVoucher.color"
            text-color="white"
            size="sm"
            :removable="!viewOnly && guestTickets.firstOrderItem.isUnpaid && guestTickets.firstOrderItem.appliedVoucher.canRemove"
            :label="guestTickets.firstOrderItem.appliedVoucher.label"
            @remove="guestTickets.firstOrderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-else-if="guestTickets.firstOrderItem.voucher"
            rounded
            dense
            :color="guestTickets.firstOrderItem.voucher.color"
            :text-color="buttonTextColor(guestTickets.firstOrderItem.voucher.color)"
            size="sm"
            :label="guestTickets.firstOrderItem.voucher.label"
            :removable="!viewOnly && guestTickets.firstOrderItem.voucher.canRemove"
            @remove="guestTickets.firstOrderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-if="guestTickets.firstOrderItem.discount && !guestTickets.firstOrderItem.itemPackage"
            rounded
            dense
            color="secondary"
            text-color="white"
            size="sm"
            :label="guestTickets.firstOrderItem.discount.displayName"
            :removable="!viewOnly && guestTickets.firstOrderItem.isUnpaid"
            @remove="order.removeDiscount(guestTickets.firstOrderItem)"
          />
          <q-chip
            v-if="guestTickets.firstOrderItem.itemPackage"
            rounded
            dense
            color="secondary"
            :text-color="buttonTextColor(currentSite.secondaryColor)"
            size="sm"
            :label="guestTickets.firstOrderItem.itemPackage.name"
          />
        </q-item-label>
        <q-item-label>
          <q-chip
            v-if="$register"
            dense
            :size="isDrawer || $q.screen.lt.sm ? 'sm' : 'md'"
            square
          >
            {{ ticketTypeDisplayName }}
          </q-chip>

          <q-chip
            v-if="ticket && ticket.showing.reservedSeating && guestTickets.seatNames"
            color="responsive-grey-3"
            dense
            :size="isDrawer || $q.screen.lt.sm ? 'sm' : 'md'"
            square
          >
            Seat{{ guestTickets.count > 1 ? 's' : '' }} {{ guestTickets.seatNames }}
          </q-chip>

          <q-btn
            v-if="$register && !viewOnly && ticket && guestTickets.needsSeatSelection"
            class="align-left q-ml-xs"
            color="negative"
            size="sm"
            dense
            outline
          >
            Select Seat
          </q-btn>
        </q-item-label>
        <q-item-section
          v-if="guestTickets.firstOrderItem.info"
          class="col-auto column q-mt-xs text-info"
        >
          {{ $_.startCase(guestTickets.firstOrderItem.info) }}
        </q-item-section>
        <q-item-label
          v-if="$register"
          overline
        >
          <q-chip
            v-if="guestTickets.firstOrderItem.appliedVoucher"
            square
            dense
            :color="guestTickets.firstOrderItem.appliedVoucher.color"
            :text-color="buttonTextColor(guestTickets.firstOrderItem.appliedVoucher.color)"
            size="sm"
            :removable="!viewOnly && guestTickets.firstOrderItem.isUnpaid && guestTickets.firstOrderItem.appliedVoucher.canRemove"
            :label="guestTickets.firstOrderItem.appliedVoucher.label"
            @remove="guestTickets.firstOrderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-else-if="guestTickets.firstOrderItem.voucher"
            square
            dense
            :color="guestTickets.firstOrderItem.voucher.color"
            :text-color="buttonTextColor(guestTickets.firstOrderItem.voucher.color)"
            size="sm"
            :label="guestTickets.firstOrderItem.voucher.label"
            :removable="!viewOnly && guestTickets.firstOrderItem.voucher.canRemove"
            @remove="guestTickets.firstOrderItem.skipVoucher = true; order.applyRedemptions()"
          />
          <q-chip
            v-if="guestTickets.firstOrderItem.discount && !guestTickets.firstOrderItem.itemPackage"
            square
            dense
            color="secondary"
            :text-color="buttonTextColor(currentSite.primaryColor)"
            size="sm"
            :label="guestTickets.firstOrderItem.discount.displayName"
            :removable="!viewOnly && guestTickets.firstOrderItem.isUnpaid"
            @remove="order.removeDiscount(guestTickets.firstOrderItem)"
          />
          <q-chip
            v-if="guestTickets.firstOrderItem.itemPackage"
            square
            dense
            color="secondary"
            :text-color="buttonTextColor(currentSite.primaryColor)"
            size="sm"
            :label="guestTickets.firstOrderItem.itemPackage.name"
          />
        </q-item-label>

        <q-item-section
          v-if="!$register"
        >
          <price
            :item="guestTickets"
            color="responsive"
          />
        </q-item-section>
      </q-item-section>
      <template v-if="$register">
        <q-item-section
          class="col-auto"
        >
          <price
            :item="guestTickets"
            class="responsive"
          />
        </q-item-section>
        <q-item-section
          class="col-auto"
        >
          <div class="column reverse justify-start items-center">
            <q-btn
              v-if="!viewOnly && guestTickets.firstOrderItem.state === 'draft' && ticket"
              class="col-auto"
              icon="fal fa-minus"
              :dense="isDrawer"
              :size="isDrawer ? 'xs': undefined"
              square
              outline
              @click.stop="$emit('remove-guest-ticket', guestTickets.firstOrderItem)"
            />
            <div
              v-if="guestTickets.count"
              class="col-auto text-center q-py-xs"
              :style="{ 'line-height': $q.platform.is.ios ? '2' : undefined }"
            >
              <span v-if="ticket">{{ guestTickets.count }}</span>
            </div>
            <q-btn
              v-if="!viewOnly && guestTickets.firstOrderItem.state === 'draft' && ticket"
              class="col-auto"
              icon="fal fa-plus"
              square
              :dense="isDrawer"
              outline
              :size="isDrawer ? 'xs': undefined"
              :disabled="order.isMaxTicketLimitReached(guestTickets.showing)"
              @mousedown="$emit('touch-hold', true, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @touchstart="$emit('touch-hold', true, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @touchleave="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @touchcancel="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @touchend="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @mouseup="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @mouseout="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              @click.stop="(event) => !event.qKeyEvent && $emit('add-guest-ticket', guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
            >
              <q-tooltip
                v-if="order.isMaxTicketLimitReached(guestTickets.showing) && order.ticketsRemaining(guestTickets.showing)"
                :offset="[10, 10]"
              >
                Max Ticket Limit Reached
              </q-tooltip>
            </q-btn>
          </div>
        </q-item-section>

        <q-item-section
          v-if="guestTickets.firstOrderItem.placed"
          class="col-auto"
        >
          <q-icon
            v-if="guestTickets.firstOrderItem.placed"
            :name="guestTickets.firstOrderItem.state === 'paid' ? 'paid' : 'lock'"
            color="grey"
          />
        </q-item-section>
      </template>

      <q-item-section
        v-else-if="!viewOnly"
        top
        side
        class="col-auto row justify-between"
      >
        <div
          v-if="ticket"
          class="row q-gutter-x-xs"
        >
          <q-btn
            v-if="guestTickets.count < 2"
            class="col-auto"
            :class="{ 'q-px-xs': isDrawer }"
            icon="fal fa-trash-can"
            color="responsive-grey-2"
            text-color="responsive"
            round
            :dense="isDrawer"
            :size="isDrawer && $consumer ? 'sm': 'md'"
            @click.stop="resetSlide => $emit('delete', guestTickets.orderItems, resetSlide)"
          >
            <q-tooltip>
              Click or swipe to remove this {{ guestTickets.count > 1 ? 'tickets' : 'ticket' }}
            </q-tooltip>
          </q-btn>
          <q-item-section
            v-if="guestTickets.firstOrderItem.state === 'draft'"
            class="col-auto"
          >
            <div class="row justify-start items-center">
              <q-btn
                v-if="guestTickets.count > 1"
                class="col-auto"
                :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
                icon="fal fa-minus"
                round
                color="responsive-grey-2"
                text-color="responsive"
                :size="isDrawer && $consumer ? 'sm': 'md'"
                data-test-id="guest-tickets-item-remove-button"
                @click.stop="$emit('remove-guest-ticket', guestTickets.firstOrderItem)"
              />
              <div
                v-if="guestTickets.count"
                class="col-auto text-center q-px-sm self-center"
                :style="{ 'line-height': $q.platform.is.ios ? '2' : undefined }"
                data-test-id="guest-tickets-item-count"
              >
                {{ guestTickets.count }}
              </div>

              <q-btn
                v-if="!!currentSite.consumerConfig.showTicketFirstCheckoutFlow"
                class="col-auto"
                :class="{ 'q-px-xs': isDrawer && $q.platform.is.ios }"
                icon="fal fa-plus"
                round
                color="responsive-grey-2"
                text-color="responsive"
                :size="isDrawer && $consumer ? 'sm': 'md'"
                data-test-id="guest-tickets-item-add-button"
                @mousedown="$emit('touch-hold', true, guestTickets.showing, guestTickets.ticketType)"
                @touchstart="$emit('touch-hold', true, guestTickets.showing, guestTickets.ticketType)"
                @touchleave="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType)"
                @touchcancel="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType)"
                @touchend="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType)"
                @mouseup="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType)"
                @mouseout="$emit('touch-hold', false, guestTickets.showing, guestTickets.ticketType)"
                @click.stop="(event) => !event.qKeyEvent && $emit('add-guest-ticket', guestTickets.showing, guestTickets.ticketType, guestTickets.firstOrderItem.itemPackage)"
              />
            </div>
          </q-item-section>
        </div>
      </q-item-section>
    </q-item>
  </q-slide-item>
</template>

<script>
import Price from 'src/modules/register/components/cart/Price'

export default {
  name: 'GuestTicketsItem',
  configuration: ['currentSite', 'currentCircuit'],
  components: {
    Price
  },
  inject: ['order'],
  props: {
    guestTickets: {
      type: Object,
      required: true,
      default: null
    },
    isDrawer: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultOpened: {
      type: Boolean,
      required: false,
      default: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['delete', 'edit', 'touch-hold', 'add-guest-ticket', 'remove-guest-ticket'],
  computed: {
    ticket () {
      return this.guestTickets.firstOrderItem.ticket
    },
    activityTicket () {
      return this.guestTickets.firstOrderItem.activityTicket
    },
    ticketTypeDisplayName () {
      /**
       * Display the quantity as part of the ticket type display name for
       * activity tickets, because we don't show the quantity and adjustment
       * buttons.
       */
      return `${this.guestTickets.ticketType.displayName} ${this.activityTicket ? ` x ${this.guestTickets.count}` : ''}`
    },
    movieOrActivityLabel () {
      if (this.ticket) {
        return `${this.ticket.showing.movie.name} - ${this.ticket.showing.formattedTime()}`
      } else if (!_.isNil(this.activityTicket?.activityLabel)) {
        return this.activityTicket.activityLabel
      } else {
        return ''
      }
    }
  },
  methods: {
    removeIcon (orderItems) {
      const orderItem = orderItems[0]
      if (orderItem.state === 'draft') {
        return {
          icon: 'delete',
          color: 'warning',
          label: 'Remove' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed && orderItem.pickPrepPrintingStatus === 'success') {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else if (orderItem.placed) {
        return {
          icon: 'delete',
          color: 'negative',
          label: 'Void' + (orderItems.length > 1 ? ' All' : '')
        }
      } else {
        return {}
      }
    },
    buttonTextColor (color) {
      // when return hex code
      if (color.startsWith('#')) return this.$isColorDark(color) ? 'white' : 'black'
      // when return value from colorOptions
      const colorHex = this.$getSiteColorHex(this.currentSite, color)
      if (!colorHex) return false
      return this.$isColorDark(colorHex) ? 'white' : 'black'
    }
  }
}

</script>
<style lang="scss" scoped>
  .q-btn--round.col-auto {
    padding: 0;
    min-height: 3em;
    min-width: 3em
  }
</style>
